<template>
  <div class="content">
    <div class="pay-result">
      <img src="./successOrFail_img/fail.png" alt="" />
      <p>支付失败</p>
      <a class="btn" href="http://happytalk.tw/mycard/newPay/pay/#/">返回</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fail',
}
</script>

<style lang="stylus" scoped>
.content {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  text-align: center;
  justify-content: center;
  align-content: center;

  .pay-result {
    position: absolute;
    top: 30%;
  }

  .btn {
    display: inline-block;
    margin-top: 20px;
    border-radius: 5px;
    padding: 6px 24px;
    background: #dc534a;
    color: #fff;
  }
}
</style>
